@if (showCustomContent) {
  <div class="ds-info-row" [style]="customStyle">
    <div class="ds-info-row-content">
      <ng-container *ngTemplateOutlet="customContent"></ng-container>
    </div>
  </div>
} @else {
  <div class="ds-info-row" [style]="customStyle" *ngIf="value !== null">
    <div class="ds-info-row-content">
      <p class="ds-ui-2 ds-color-core-neutral-7">{{ title | translate }}</p>
      <div>
        <p class="ds-ui-2 ds-color-core-neutral-10" [innerHTML]="value"></p>
        <app-ds-icon name="info" color="var(--color-core-neutral-5)" (click)="clickInfo()" *ngIf="info"></app-ds-icon>
      </div>
    </div>
    <div *ngIf="showInfo" class="extra-info">
      <p class="ds-color-core-neutral-7 ds-ui-3" [innerHTML]="info | translate"></p>
    </div>
  </div>
}
